/* eslint-disable no-undef, react/prop-types */
import React from 'react';
import { css } from 'react-emotion';
import Img from 'gatsby-image';
import { Box } from '../components/Layout';
import colors from '../utils/colors';

const style = css`
  text-align: center;
  padding-bottom: 10%;
  color: ${colors.primary};
  div {
    p {
      margin-top: 2em;
    }
  }
`;

const startStyle = css`
  margin-top: 2em;
`;

const logoStyle = css`
  height: 50%;
  padding: 0;
  margin-left: auto;
  margin-right: auto;
`;

const outerImgWrapper = css`
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 2em;
`;

const vimeoWrapper = css`
  margin-top: 1em;
  margin-bottom: 1em;
`;

const Teoksesta = ({ data }) => {
  const { logo, kakarat } = data;
  return (
    <Box>
      <Box
        className={style}
        width={[1, 1, 1 / 2]}
        m={['3.5rem 0 0 0', '3.5rem 0 0 0', '3.5rem auto 0 auto']}
        px={[3, 3, 0]}
        color={colors.secondary}
      >
        <div className={startStyle}>
          <Img
            alt="kakarat"
            sizes={kakarat.childImageSharp.sizes}
            imgStyle={{ objectFit: 'contain' }}
          />
          <p>
            Kotona Tytti kokee olevansa näkymätön. Paetessaan taianomaiseen
            unimaailmaan Tytti kohtaa muuttuneen Owlan. Ennen niin herttainen
            kaupunki on nyt harmaa ja kolea. Tullissa kaikki jaetaan meihin ja
            toisiin, Merikoskenneidoista kaunein on kadonnut eikä
            Molloplaanallakaan raikaa enää Tervaporvarien päivätanssit.
          </p>
          <p>
            Kaupunkiin saapunut Apteekkari eliksiireineen on saanut Owlan aivan
            sekaisin. Ystävykset Tytti, Maija ja Franz tempautuvat elämänsä
            seikkailuun yrittäessään pelastaa Owlan ahneen Apteekkarin kynsistä.
          </p>
          <p>
            Löytääkö kolmikko Owlan kadonneen walkian? Mitä kummaa Apteekkari
            aikoo tehdä valtavalla kuumailmapallollaan? Entä mitä tapahtuu, kun
            Tytti palaa unimaailmastaan kotiin? Onnistuuko perhe vihdoin
            kohtaamaan toisensa?
          </p>
          <Img
            alt="logo"
            sizes={logo.childImageSharp.sizes}
            outerWrapperClassName={outerImgWrapper}
            imgStyle={{
              objectFit: 'contain'
            }}
          />
          <p>
            Elena Vuoksiolan käsikirjoittama Owla ja kadonnut walkia kutsuu koko
            perheen kohtaamisten, tanssin riemun ja juurevan kansanmusiikin
            äärelle. Owlassa sadun taika kietoutuu suomalaiseen
            kansanperinteeseen ja Oulun paikallishistoriaan. Yli 90 eri-ikäistä
            oululaista ammattitanssijaa ja kansantanssin harrastajaa yhdistävät
            voimansa tässä kansantanssin suurproduktiossa.
          </p>
          <p>
            Owla ja kadonnut walkia on itsenäinen jatko-osa vuonna 2014
            kantaesitetylle Owla – tanssiseikkailulle. Owla – tanssiseikkailu
            palkittiin Suomen Nuorisoseurojen ja Folklandian myöntämällä Vuoden
            tanssiteko 2014 -tunnustuksella.
          </p>
        </div>
        <div className={vimeoWrapper}>
          <iframe
            src="https://player.vimeo.com/video/95659321?title=0&byline=0&portrait=0"
            width="100%"
            height="360"
            frameBorder="0"
            title="Owla"
            webkitallowfullscreen
            mozallowfullscreen
            allowFullScreen
          />
        </div>
      </Box>
    </Box>
  );
};

export const query = graphql`
  query TeoksestaQuery {
    logo: file(relativePath: { eq: "owla_logo_bright.png" }) {
      childImageSharp {
        sizes(maxWidth: 1024) {
          ...GatsbyImageSharpSizes_noBase64
        }
      }
    }
    kakarat: file(relativePath: { eq: "kakarat.png" }) {
      childImageSharp {
        sizes(maxWidth: 1024) {
          ...GatsbyImageSharpSizes_noBase64
        }
      }
    }
  }
`;

export default Teoksesta;



// WEBPACK FOOTER //
// ./src/pages/teoksesta.js